import * as ko from "knockout";
import { ContractYearList } from "../Models/Pdf/ContractYearList";
import { groupBy, map, orderBy, forEach, isEmpty } from "lodash-es";
import { PdfInfo } from "../Models/Pdf/PdfInfo";
import { SettingsApi } from "../Apis/SettingsApi";  

export class ContractConditionsViewModel {
    completeList = ko.observableArray<PdfInfo>();
    expirationDate: Date;

    constructor() {
        SettingsApi.getInstance().getExpirationDate().then((res) => this.expirationDate = res);
    }

    isNew(date:Date): boolean {
        return date > this.expirationDate;
    }
    /*
     * Collection used for the graphic table representations.
     */
    private groupedByYear: KnockoutComputed<ContractYearList[]> = ko.computed(() => {

        let list = new Array<ContractYearList>();
        var groupedList = groupBy(orderBy(this.completeList(), c => c.DateAndTime.getFullYear()), (item) => item.DateAndTime.getFullYear());
        forEach(groupedList, e => {
            const year = e[0].DateAndTime.getFullYear();
            list.push(new ContractYearList(year, e));
        });

        return orderBy(list, c => c.Year, 'desc');
    });
}